import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Divider,
  Card,
  CardMedia,
} from "@mui/material";
import { Check } from "@mui/icons-material";
import axiosInstance from "../../../../utils/axiosConfig";

function ServiceDetail() {
  const { id } = useParams();
  const [service, setService] = useState(null);

  useEffect(() => {
    fetchServiceDetail();
  }, [id]);

  const fetchServiceDetail = async () => {
    try {
      const response = await axiosInstance.get(`/service_offerings/${id}`);
      setService(response.data);
    } catch (error) {
      console.error("Error fetching service details:", error);
    }
  };

  if (!service) return null;

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 8 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom>
            {service.title}
          </Typography>

          {service.image_url && (
            <Card sx={{ mb: 4 }}>
              <CardMedia
                component="img"
                height="400"
                image={service.image_url}
                alt={service.title}
              />
            </Card>
          )}

          <Divider sx={{ my: 4 }} />

          <Typography variant="h5" gutterBottom sx={{ color: "#29474d" }}>
            Descripción Detallada
          </Typography>
          <Typography variant="body1" paragraph>
            {service.full_description}
          </Typography>

          <Box sx={{ mt: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ color: "#29474d" }}>
              Beneficios
            </Typography>
            <List>
              {service.benefits.map((benefit, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <Check sx={{ color: "#FFD700" }} />
                  </ListItemIcon>
                  <ListItemText primary={benefit} />
                </ListItem>
              ))}
            </List>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default ServiceDetail;
